import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

import {
  matchSize,
  TableData,
  TableRow,
  TableRowType,
} from '@make-software/cspr-design';

export enum SectionTableLoaderType {
  SectionTableLine = 'SectionTableLine',
}

type Props = {
  columnsLength: number;
  rowsLength?: number;
  tableRowType?: TableRowType | SectionTableLoaderType;
};

type TableLoaderRowProps = {
  type: TableRowType | SectionTableLoaderType;
};

const TableLoaderRow = styled(TableRow)<TableLoaderRowProps>(
  ({ theme, type }) => ({
    height: matchSize(
      {
        [TableRowType.TextWithAvatar]: '60px',
        [TableRowType.TextWithIcon]: '56px',
        [TableRowType.TextSingleLine]: '52px',
        [SectionTableLoaderType.SectionTableLine]: '172px',
      },
      type
    ),
  })
);

export function TableLoader({
  columnsLength,
  rowsLength = 10,
  tableRowType = TableRowType.TextSingleLine,
}: Props) {
  const tableData = Array(rowsLength).fill(undefined);
  const columnsRow = Array(columnsLength).fill(null);
  const skeletonHeight =
    tableRowType === SectionTableLoaderType.SectionTableLine ? 100 : undefined;
  return (
    <>
      {tableData.map((item, index) => (
        <TableLoaderRow key={'row' + index} type={tableRowType} loading>
          {columnsRow.map((item2, index2) => (
            <TableData key={'column' + index2}>
              <Skeleton height={skeletonHeight} />
            </TableData>
          ))}
        </TableLoaderRow>
      ))}
    </>
  );
}
